import React from 'react';
import moment from 'moment-timezone';
import { LocalizationProvider } from '@mui/x-date-pickers';
import { AdapterMoment } from '@mui/x-date-pickers/AdapterMoment';

export const MuiDateProvider: React.FC = ({ children }) => (
  <LocalizationProvider dateAdapter={AdapterMoment} dateLibInstance={moment}>
    {children}
  </LocalizationProvider>
);
